<script>

</script>

<style>
    .container {
        width: 100%;
		height: 100vh;
        overflow: visible;
        position: relative;
    }

    .imageBackground {
        position: absolute;
        width: 100%;
        height: 100%;
        background-size: 160% 160%;
        background-repeat: no-repeat;
        background-position:  center center;
        background-image: url('./../images/slalom-artwork.svg');
    }

    .content {
        position: absolute;
        top: 100px;
        left: 60px;
        display: flex;
        flex-flow: column nowrap;
    }

    .tagline {
        display: block;
        color: white;
        font-size: 25px;
        font-weight: 200;
        max-width: 400px;
        width: 100%;
    }

    .httpiness {
        width: 140px;
        height: 26px;        
        display: inline-block;
        position: relative;
        top: 6.5px;
        background-position: center left;
        background-size: contain;
        background-repeat:no-repeat;
        background-image: url('./../images/wordmark.svg');
    }

    .downloadTitle {
        margin-top: 30px;
        font-weight: 700;
        color: white;
        letter-spacing: 4px;
    }

    .dists {
        margin-top: 10px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    .dists img {
        height: 20px;
        margin-right: 30px;
    }

    @media (min-width: 750px) {
		.container {
            max-height: 70vw;
		}
	}

    @media (max-width: 749px) {
        .imageBackground {
            background: none;
        }
	}

    @media (max-width: 749px) and (min-height: 500px) {
        .container {
            max-height: 50vh;
        }
    }

    @media (max-width: 1000px) {
        .content {
            top: 50px;
            left: 50px;
        }
	}

    @media (max-width: 500px) {
        .content {
            top: 40px;
            left: 20px;
        }

        h1 {
            font-size: 18px;
        }

        .tagline {
            padding-right: 20px;
        }
	}
</style>

<div class="container">
    <div class="imageBackground" />
    <div class="content">
        <h1 class="tagline"><span class="httpiness" /> 
            is developer-oriented HTTP client for slalom API testing.
        </h1>
        <a href="#download">
            <div class="downloadTitle">DOWNLOAD NOW</div>
            <div class="dists">
                <img src="./images/distributions/win32.svg" alt="Windows" />
                <img src="./images/distributions/macos.svg" alt="macOS" style="height: 15px;" />
            </div>
        </a>
    </div>
</div>
